import { render, staticRenderFns } from "./SocketOut.vue?vue&type=template&id=1806def5&scoped=true&"
import script from "./SocketOut.vue?vue&type=script&lang=js&"
export * from "./SocketOut.vue?vue&type=script&lang=js&"
import style0 from "./SocketOut.vue?vue&type=style&index=0&id=1806def5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1806def5",
  null
  
)

export default component.exports